import React, { Component } from 'react';
import { Badge, Button, Card, CardBody, Col, Row } from "reactstrap";
import * as moment from 'moment';
import 'moment-timezone';
import PriceFormatter from "../misc/PriceFormatter";
import connect from "react-redux/es/connect/connect";
import { setTicket } from "../../redux/actions/ticket";

class FlightItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,

            adultNo: this.props.adultNo,
            childNo: this.props.childNo,
            infantNo: this.props.infantNo,
            orgTicket: this.props.data,
            ticket: this.props.ticket,

            redirect: false,
            departureAirport: this.props.departureAirport,
            arrivalAirport: this.props.arrivalAirport,
            arrivalDate: this.props.arrivalDate,
            arrivalTime: this.props.arrivalTime,
            departureTime: this.props.departureTime,
            airLine: this.props.airLine,
            showMore: false
        };
    }



    render() {
        return (
            <Card className="white mb-3 w-100 flight-item">
                <CardBody className={this.props.ticket.availableSeat === 0 ? "pb-0 unavalable-tickets" : "pb-0"}>
                    <Row>
                        <Col md={9}>
                            <Row>
                                <div className='ticket-body'>
                                    <div className='ticket-image'>
                                        <img src={`./../../assets/images/${this.props.airLine.icon}`} alt={this.props.airLine.name}
                                            className='ticket-logo' />
                                        <p className="d-none d-md-block d-lg-block company-title">{this.props.airLine.name}</p>
                                    </div>
                                    <div className='ticket-from'>
                                        {/* <p><i className='fa fa-clock-o ' /> {this.props.departureTime} </p> */}
                                        <p><i className='fa fa-map-marker' /> {this.props.departureAirport.city} <span>{this.props.departureTime}</span></p>
                                    </div>
                                    <div className='ticket-arrow'>
                                        <p className='ticket-date'>{this.props.arrivalDate}</p>
                                        <div className="arrow">
                                            {/* <span className="icon icon-airplane-line w-normal" /> */}
                                            <img className='start-piont-img' src='/assets/images/plane.png' alt='small-plane' />
                                            <span className="arrow-width" />
                                            <i className='end-point' ></i>
                                        </div>
                                        {/*<p className='ticket-date'>{flightDuration}</p>*/}
                                    </div>
                                    <div className='ticket-to'>
                                        {/* <p><i className='fa fa-clock-o ' />{this.props.arrivalTime}</p> */}
                                        <p><i className='fa fa-map-marker' /> {this.props.arrivalAirport.city} <span>{this.props.arrivalTime}</span></p>

                                    </div>
                                </div>
                            </Row>
                        </Col>
                        <Col md={3} className='text-center ticket-price '>
                            <p className='price'>
                                <PriceFormatter
                                    className="item-price"
                                    data={this.props.ticket.totalFare}
                                    type="airplane"
                                    date={moment(this.props.arrivalDate, 'dd DD MMM').format("YYYY-M-D")}
                                />
                            </p>
                            {/*  {!isAuthenticated ? <LoginModal/>:
                            <Button color="info" block active={true} className="book-btn">Book Ticket</Button>
                        }*/}
                            {this.props.ticket.availableSeat === 0 ?
                                <Button color="info" block active={true} className="book-btn"
                                >Unavailable</Button>
                                :
                                <Button color="info" block active={true} className="book-btn"
                                    onClick={this.handleClick.bind(this)} >Book Ticket</Button>}

                            <p className='available-seat'> {this.props.ticket.availableSeat} Seat is available</p>
                        </Col>
                    </Row>
                    <Row className="d-none d-md-block d-lg-block">
                        <Button color="link" block active={true} className="book-btn more-info-but"
                            onClick={() => this.setState({ showMore: !this.state.showMore })}>
                            More Info <i className={this.state.showMore ? "la la-angle-down" : "la la-angle-up"} />
                        </Button>
                    </Row>
                    {this.state.showMore ?
                        <Row className="d-none d-md-block d-lg-block m-4 mt-0 showMore-content">
                            <div className='flight-features'>
                                <div className='flight-no'><span>Flight no:</span> {this.props.ticket.flightNumber}</div>
                                {(this.props.ticket.airEquipType === "-1") ? "" :
                                    <div className='plane-type'>{this.props.ticket.airEquipName}</div>
                                }
                                <div className='flight-class'>{this.props.ticket.bookingClassAvail}</div>
                                <div className='flight-type'>{this.props.ticket.isChartered ?
                                    <Badge color="danger">Charter</Badge> :
                                    <Badge color="primary">Standard</Badge>
                                }</div>
                                <div className="more-info-from-div">
                                    <span>From :</span>
                                    <p className="d-none d-md-block d-lg-block"><i
                                        className='' /> {this.props.departureAirport.name} </p>
                                </div>
                                <div className="more-info-from-div" >
                                    <span>To :</span>
                                    <p className="d-none d-md-block d-lg-block"><i
                                        className='' /> {this.props.arrivalAirport.name}  </p>
                                </div>


                            </div>
                        </Row>
                        : ""}
                </CardBody>
            </Card>
        );
    }
    handleClick() {
        const { orgTicket, ticket, adultNo, childNo, infantNo } = this.props;
        this.props.setTicket(orgTicket, ticket, adultNo, childNo, infantNo);
        // this.setState({redirect:true});
        // this.props.history.push('/ticket-passengers');
        window.location.replace("/ticket-passengers");

    }

}
const mapDispatchToProps = dispatch => {
    return {
        setTicket: (orgTicket, ticket, adultNo, childNo, infantNo) => {
            dispatch(setTicket(orgTicket, ticket, adultNo, childNo, infantNo))
        }
    }
};

const mapStateToProps = (state) => {
    return {
        user: state.user,
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(FlightItem)


// WEBPACK FOOTER //
// ./src/components/search/FlightItem.js